<template>
  <ContentWrap>
    <el-result
      icon="info"
      :title="`${workspaceLabel}工作台`"
      sub-title="正在加载该工作台的业务菜单与数据范围"
    >
      <template #extra>
        <el-button
          type="primary"
          @click="router.push('/ai-Application-center/ai-education/overview')"
        >
          返回 AI 教育概览
        </el-button>
      </template>
    </el-result>
  </ContentWrap>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

defineOptions({ name: 'AiEducationRoleLanding' })

const route = useRoute()
const router = useRouter()
const labels: Record<string, string> = {
  teacher: '教师',
  student: '学生',
  parent: '家长',
  principal: '校长',
  researcher: '教研员',
  regionAdmin: '区域管理员',
  platformAdmin: '平台管理员'
}
const workspaceLabel = computed(() => labels[String(route.params.workspace)] || 'AI 教育')
</script>
